// extracted by mini-css-extract-plugin
export default {"success":"PungoSnackbar_success__h1Hst","error":"PungoSnackbar_error__jPbXB"};